import React, { useState, useEffect } from "react";
import "./style.css";
import { Helmet, HelmetProvider } from "react-helmet-async";
import Typewriter from "typewriter-effect";
import { introdata, meta } from "../../content_option";
import { Link } from "react-router-dom";
import { useTheme } from '../../themeContext'; // Import the useTheme hook
import darkThemeCubeImage from '../../assets/images/rubiks_cube_cyan.png';
import lightThemeCubeImage from '../../assets/images/rubiks_cube_yellow.png';

export const Home = () => {
  const { theme } = useTheme(); // Use the context to get the current theme

  // Determine which logo to use based on the theme
  const cubeImageUrl = theme === 'dark' ? darkThemeCubeImage : lightThemeCubeImage;

  return (
    <HelmetProvider>
      <section id="home" className="home">
        <Helmet>
          <meta charSet="utf-8" />
          <title> {meta.title}</title>
          <meta name="description" content={meta.description} />
        </Helmet>
        <div className="intro_sec d-block d-lg-flex align-items-center ">
          <div className="h_bg-image order-1 order-lg-2 h-100"
            style={{ display: 'flex', justifyContent: 'center', alignItems: 'center' }}
          >
            <img src={cubeImageUrl} alt="" style={{ width: '50%' }} />
          </div>
          <div className="text order-2 order-lg-1 h-100 d-lg-flex justify-content-center">
            <div className="align-self-center ">
              <div className="intro mx-auto">
                <h2 className="mb-1x">{introdata.title}</h2>
                <h3 className="fluidz-48 mb-1x" style={{lineHeight:"2"}}>
                  <Typewriter
                    onInit={(typewriter) => {
                      typewriter
                        .pauseFor(1000)
                        .typeString(introdata.animated.first)
                        .start();
                    }}
                    options={{
                      cursor: '_',
                      delay: 25,
                    }}
                  />
                </h3>
                <p className="mb-1x">{introdata.description}</p>
                <div className="intro_btn-action pb-5">
                  <Link to="/about" className="text_2">
                    <div id="button_p" className="ac_btn btn ">
                      About Me 
                      <div className="ring one"></div>
                      <div className="ring two"></div>
                      <div className="ring three"></div>
                    </div>
                  </Link>
                  <Link to="/contact">
                    <div id="button_h" className="ac_btn btn">
                      Contact Me
                      <div className="ring one"></div>
                      <div className="ring two"></div>
                      <div className="ring three"></div>
                    </div>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </HelmetProvider>
  );
};
